import { put, take, call } from 'redux-saga/effects';
import { GET_USER_DETAILS_REQUEST } from './types';

import { setUserRoles } from '../../../reducers/userSessionSlice';
import { GetUserDetailsApi } from '../../../api/lelyBackend/userDetails';
import withLoading from '../../../sagas/loadingSaga';
import { setPreferredLanguage } from '../../../reducers/translationSlice';

export default function* getUserDetailsSaga(api: GetUserDetailsApi) {
  while (true) {
    yield take(GET_USER_DETAILS_REQUEST);
    yield* withLoading(function* () {
      yield call(getUserDetailsRequest, api);
    });
  }
}

function* getUserDetailsRequest(api: GetUserDetailsApi) {
  try {
    const allUserDetails = yield call(api.getUserDetails);
    const { roles, language } = allUserDetails.data;
    yield put(setUserRoles(roles));
    yield put(setPreferredLanguage(language));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to get user roles:', error);
  }
}
